/**
 * Create a new cookie
 *
 * @param name {String}
 * @param value {*}
 * @param days {Number}
 */
export const create = ({ name, value, days }) => {
  let expires;

  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = `; expires=${date.toUTCString()}`;
  } else {
    expires = '';
  }

  document.cookie = `${name}=${value}${expires}; path=/`;
};

export default {
  create,
};
